
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Utils = {
        toggleElementDisplay: function (element, show, displayStyle = 'flex') {
            if (element) {
                element.style.display = ''; 
                element.classList.remove('invisible', 'flex', 'visible');
                
                if (show) {
                    const className = displayStyle === 'flex' ? 'flex' : 'visible';
                    element.classList.add(className);
                } else {
                    element.classList.add('invisible');
                }
            }
        },

        updateArrowState: function (arrow, isDisabled) {
            if (!arrow) return;

            if (isDisabled) {
                arrow.classList.add('disabled');
                arrow.style.opacity = '0.3';
                arrow.style.pointerEvents = 'none';
            } else {
                arrow.classList.remove('disabled');
                arrow.style.opacity = '1';
                arrow.style.pointerEvents = 'auto';
            }
        },

        normalizeStockData: function (data) {
            if (!data) return [];
            return Array.isArray(data) ? data : Object.values(data);
        },

        getStockProperty: function (stock, property, defaultValue = 0) {
            return parseFloat(stock[property]) || defaultValue;
        },

        setupDropdown: function (dropdownBtn, dropdown, dropdownItems, labelElement, onSelectCallback = null) {
            if (!dropdownBtn || !dropdown) return;

            dropdownBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                dropdown.classList.toggle('active');
            });

            if (dropdownItems && labelElement) {
                dropdownItems.forEach(item => {
                    item.addEventListener('click', function (e) {
                        e.stopPropagation();
                        const label = this.textContent;

                        labelElement.textContent = label;
                        dropdownItems.forEach(i => i.classList.remove('active'));
                        this.classList.add('active');
                        dropdown.classList.remove('active');

                        if (onSelectCallback) {
                            onSelectCallback(this);
                        }
                    });
                });
            }

            document.addEventListener('click', function (e) {
                if (dropdown && !dropdown.contains(e.target)) {
                    dropdown.classList.remove('active');
                }
            });
        },

        SORT_CONFIG: {
            alphabetical: {
                getValue: (stock) => (stock.ticker || '').toLowerCase(),
                useLocaleCompare: true
            },
            total_dollar_value_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const price = parseFloat(stock.price) || 0;
                    const totalCostBasis = parseFloat(h.price) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    return (price * qty) - totalCostBasis;
                }
            },
            value_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const change = parseFloat(stock.todaysChange) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    return change * qty;
                }
            },
            price_change_dollar: {
                getValue: (stock) => parseFloat(stock.todaysChange) || 0
            },
            total_percent_price_change: {
                getValue: (stock, holdings) => {
                    if (!holdings || !holdings[stock.ticker]) return null;
                    const h = holdings[stock.ticker];
                    const price = parseFloat(stock.price) || 0;
                    const totalCostBasis = parseFloat(h.price) || 0;
                    const qty = parseFloat(h.quantity) || 0;
                    if (totalCostBasis === 0) return 0;
                    return (((price * qty) - totalCostBasis) / totalCostBasis) * 100;
                }
            },
            price_change_percent: {
                getValue: (stock) => parseFloat(stock.todaysChangePerc) || 0
            }
        },

        sortStockData: function (data, option, order, holdings) {
            const sorted = [...data];
            const multiplier = order === 'asc' ? 1 : -1;
            
            const config = this.SORT_CONFIG[option];
            
            if (!config) return sorted;

            sorted.sort((a, b) => {
                const valA = config.getValue(a, holdings);
                const valB = config.getValue(b, holdings);
                const hasA = (valA !== null && valA !== undefined);
                const hasB = (valB !== null && valB !== undefined);
                
                if (hasA !== hasB) {
                    if (hasA) return -1;
                    return 1;
                }
                
                if (!hasA && !hasB) {
                     return (a.ticker || '').localeCompare(b.ticker || '');
                }

                if (config.useLocaleCompare) {
                    return valA.localeCompare(valB) * multiplier;
                }

                if (valA < valB) return -1 * multiplier;
                if (valA > valB) return 1 * multiplier;
                return 0;
            });

            return sorted;
        },

        getCurrentUsername: function () {
            let username = "";
            try {
                if (window.currentSession?.user) {
                    const u = window.currentSession.user;
                    console.log("[getCurrentUsername] checking user_metadata", u.user_metadata);
                    if (u.user_metadata?.display_name) return u.user_metadata.display_name;
                    if (u.email) return u.email.split('@')[0];
                }
            } catch (e) {
                console.warn("Could not determine username:", e);
            }
            return username;
        },

        truncateName: function (name, length = 20) {
            if (!name) return "";
            if (name.length <= length) return name;
            return name.substring(0, length) + "...";
        }
    };

    window.WatchlistApp.Utils = Utils;
})();
